export const organizationTree = {
    addChild: '添加子公司',
    organization: '组织架构',
};
